"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Try to find the Babel options for a Babel plugin.
//
// This is made way harder than it sounds by Babel's internal architecture.
// When `manipulateOptions` hook is being run, Babel doesn't specify the options
// of the individual plugin -- only the global Babel configuration. But we need
// the local options for the LightScript plugin in order to manipulate the parser
// flags.
//
// The cherry on top is that in order to GET the local options for the lightscript
// plugin, you have to find the lightscript plugin in the Babel plugin list, but
// Babel performs internal transformations on the plugin data structure that
// make it impossible to determine post hoc which one is the Lightscript plugin.
// Except for one loophole: the `manipulateOptions` function itself is not mutated
// by Babel.
//
// So, basic strategy is to iterate all the Babel plugins, find the one whose
// `manipulateOptions` function matches ours, then return the options for
function isPlugin(a, b) {
  return a.manipulateOptions === b.manipulateOptions;
}
exports.default = function findBabelOptionsForPlugin(opts, targetPlugin) {
  var plugins = opts == null ? void 0 : opts.plugins;
  if (!plugins) return {};

  for (var _i2 = 0, _len2 = plugins.length; _i2 < _len2; _i2++) {
    var _plugin = plugins[_i2];
    if (Array.isArray(_plugin)) {
      // babel plugin opts are in the second elt of the array describing the plugin
      if (isPlugin(targetPlugin, _plugin[0])) return _plugin[1] || {};
    } else {
      if (isPlugin(targetPlugin, _plugin)) return {};
    }
  }return {};
};

module.exports = exports["default"];